export class Perform {
    id: string;
    name: string;
    created_at: string;
    items: Item[];
    job_id: string;
    status: number;
    updated_at: string;
};

export class Item {
  id: number;
  name: string;
  poll_id: number;

  description: number;
  status: number;
  created_at: string;
  updated_at: string;
  url: string;
};

export class Pagination {
  total: number;
  pages: number;
  pageCount: number;
}

export class PaginatedPerforms {
  pagination: Pagination;
  applicants: Item[];
}



// WEBPACK FOOTER //
// /var/www/_deploy/front-company-testing/2018-09-30-21-57-10/src/app/models/perform.ts